export default __webpack_public_path__ + "static/media/doc.ea5300e8.svg";